/**
 * Single admin URL space. `/admin/app/*` redirects to `/admin/*`.
 */

export const ADMIN_BASE = '/admin';

/** @deprecated Use ADMIN_BASE — kept so existing imports keep working. */
export const CLASSIC_ADMIN_PREFIX = ADMIN_BASE;

/** @deprecated Use ADMIN_BASE — kept so existing imports keep working. */
export const ENTERPRISE_ADMIN_BASE = ADMIN_BASE;

export function getAdminPostLoginPath(): string {
  return `${ADMIN_BASE}/dashboard`;
}

export function isEnterprisePath(_pathname: string): boolean {
  return true;
}
